import React, { Component } from "react";
import { Link } from "react-router-dom";

class BlogHeader extends Component {
  render() {
    let HeaderTitle = this.props.headertitle;
    let publicUrl = process.env.PUBLIC_URL;
    let Subheader = this.props.subheader ? this.props.subheader : HeaderTitle;

    return (
      <>
        <style>
          {`
            .custom-blog-header {
              background-image: url('${publicUrl}/assets/HeaderImg/3.png');
              background-size: cover;
              background-position: center;
              position: relative;
              box-shadow: inset 0 0 100px rgba(0,0,0,0.2);
              height: 500px;
            }

            @media (max-width: 768px) {
              .custom-blog-header {
                background-image: url('${publicUrl}/assets/HeaderImg/1.png');
              }
            }
          `}
        </style>

        <div className="breadcrumb-area jarallax custom-blog-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner">
                  <h2 className="page-title">{HeaderTitle}</h2>
                  <ul className="page-list">
                    <li><Link to="/">Home</Link></li>
                    <li>{Subheader}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default BlogHeader;
